export class HisInformationForceUpdateParameter {
  shouldUpdateExtraSectionOnly: boolean;
  shouldUpdatePatientInformation: boolean;
  shouldUpdateAllInformation: boolean;
}
